export default function splitVersioncode (versioncode: string) {
    const result = {MAJOR: '0', MINOR: '0', FIX: '0'}
    const splittedCode = versioncode.split('-')[0].split('.');
    result.MAJOR = splittedCode[0];
    result.MINOR = splittedCode[1];
    result.FIX = splittedCode[2];
    return result
}